export default __webpack_public_path__ + "static/media/blue.933d7cc5.svg";